import { useEffect, useRef, useState } from "react"
import { useRouter } from "next/router"
import { useApolloClient, useMutation } from "react-apollo"

import { CURRENT_USER_QUERY } from "../me/me"
import { SYNC_CHECKOUT_SESSION } from "../onboarding/queries"

import "./upgrade-dialog.scss"

// These pages handle their own Checkout return.
const OWN_RETURN = ["/pricing", "/welcome"]

// Stripe Checkout from the upgrade dialog comes back to the page it started
// on with ?checkout=done&session_id=…. Apply it now rather than waiting for
// the webhook, say so, and tidy the URL. Never throws: it lives in the page
// shell, where a render error loops (see Page).
const CheckoutReturn = () => {
  const router = useRouter()
  const client = useApolloClient()
  const [syncCheckout] = useMutation(SYNC_CHECKOUT_SESSION)
  const [note, setNote] = useState(null)
  const done = useRef(false)

  const q = (router && router.query) || {}
  const sessionId = q.checkout === "done" && typeof q.session_id === "string" ? q.session_id : null

  useEffect(() => {
    if (done.current || !sessionId || OWN_RETURN.includes(router.pathname)) return
    done.current = true
    syncCheckout({ variables: { sessionId } })
      .then(({ data }) => {
        const trial = data.syncCheckoutSession.subscriptionStatus === "trialing"
        setNote(trial ? "You're on Premium. Your free trial has started." : "You're on Premium.")
        return client.query({ query: CURRENT_USER_QUERY, fetchPolicy: "network-only" })
      })
      .catch(() => setNote("Your payment went through. Premium can take a minute to switch on; refresh if it hasn't."))
      .then(() => {
        // the URL only; a Next route change would need each page's href
        try {
          const url = new URL(window.location.href)
          url.searchParams.delete("checkout")
          url.searchParams.delete("session_id")
          window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash)
        } catch (e) {}
      })
  }, [sessionId])

  if (!note) return null
  return (
    <div className="checkout-return" role="status">
      <p>{note}</p>
      <button type="button" onClick={() => setNote(null)}>
        Close
      </button>
    </div>
  )
}

export default CheckoutReturn
